const GridNoResultsOverlay = () => (
  <div className="MuiDataGrid-overlay css-xr00fv-MuiDataGrid-overlay">
    No hay resultados para mostrar
  </div>
)

export default GridNoResultsOverlay
